// extracted by mini-css-extract-plugin
module.exports = {"image":"ClassicPreviewImage_image__4wO_t"};